'use strict';exports.__esModule = true;exports.axiosMailingInstance = undefined;var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _defaults = require('axios/lib/defaults');var _defaults2 = _interopRequireDefault(_defaults);
var _constants = require('../constants');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

_defaults2.default.baseURL = _constants.apiURL;

var axiosAnalyticsInstance = _axios2.default.create({
  baseURL: _constants.analyticsApiURL });


var axiosMailingInstance = exports.axiosMailingInstance = _axios2.default.create({
  baseURL: _constants.mailingApiURL });exports.default =


axiosAnalyticsInstance;


//////////////////
// WEBPACK FOOTER
// ./src/helpers/axiosConfig.js
// module id = 384
// module chunks = 0